import React, { useState, useEffect } from "react";
import ErrorMessage from "../../Components/ErrorMessage";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import { BiCopy } from "react-icons/bi";

const NewAccess = () => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const navigate = useNavigate();
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [accessName, setAccessName] = useState("")
    const [accessSurname, setAccessSurname] = useState("")
    const [accessEmail, setAccessEmail] = useState("")
    const [accessPassword, setAccessPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)

    const [erioonDB, setErioonDB] = useState("read");
    const [erioonInfinity, setErioonInfinity] = useState("viewAccess");

    const [records, setRecords] = useState([]);
    const [projectId, setProjectId] = useState(null)

    const { project_id } = useParams()
    const [accessType, setAccessType] = useState("GA")
    const [copiedSecret, setCopiedSecret] = useState(false);

    const handleCopyClick = () => {
        const key = `${accessEmail}:${accessPassword}`
        navigator.clipboard.writeText(key);
        setCopiedSecret(true);
        setTimeout(() => setCopiedSecret(false), 2000);
    };

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_projects", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });
            setLoading(false)
            if (response.ok) {
                const result = await response.json();
                const projectsData = result.projects || {};

                const recordsArray = Object.values(projectsData);

                setRecords(recordsArray);
            } else {
                setErr({
                    message: t.err_page,
                    display: true,
                });
            }
        } catch (err) {
            setLoading(false)
            setErr({
                message: t.err_page,
                display: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const generateRandomCredentials = () => {
        const randomId = Math.random().toString(36).substring(2, 6);
        const randomEmail = `restapi.${projectId}.${randomId}@erioon.rest`;
        const randomName = "REST";
        const randomSurname = "API";

        setAccessName(randomName)
        setAccessSurname(randomSurname)
        setAccessEmail(randomEmail)
        setErioonDB("write")
        setErioonInfinity("viewAccess")

        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
        let randomPassword = "";
        const array = new Uint32Array(12);
        window.crypto.getRandomValues(array);
        for (let i = 0; i < 12; i++) {
            randomPassword += chars[array[i] % chars.length];
        }
        setAccessPassword(randomPassword)
    };



    const goBack = () => {
        navigate(`/project_panel/${project_id}/access`);
    };

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateEmail = (email) => {
        return emailRegex.test(email);
    };

    const handleSave = async () => {

        if (!accessName.trim()) {
            setErr({ message: t.access.new_access.err_name, display: true });
            return;
        }
        if (!accessSurname.trim()) {
            setErr({ message: t.access.new_access.err_surname, display: true });
            return;
        }

        if (!accessEmail.trim()) {
            setErr({ message: t.access.new_access.err_email, display: true });
            return;
        } else if (!validateEmail(accessEmail)) {
            setErr({ message: t.access.new_access.err_email_format, display: true });
            return;
        }

        if (!accessPassword.trim()) {
            setErr({ message: t.access.new_access.err_password, display: true });
            return;
        }

        setErr({ message: "", display: false });

        const data = {
            user_id,
            project_id: projectId,
            access_name: accessName,
            access_surname: accessSurname,
            access_email: accessEmail,
            access_password: accessPassword,
            erioonDB: erioonDB,
            erioonInfinity: erioonInfinity,
            accessType: accessType
        };

        try {
            setLoading(true);
            const response = await fetch("https://backend.erioon.com/save_access", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            setLoading(false);

            if (response.ok) {
                navigate(`/project_panel/${project_id}/access`);
            } else {
                setErr({
                    message: t.err_page,
                    display: true,
                });
            }
        } catch (error) {
            setLoading(false);
            setErr({
                message: t.err_page,
                display: true,
            });
        }
    };

    const handleErioonDBPermissions = (permissionType) => {
        setErioonDB(permissionType);
    };

    const handleErioonInfinityPermissions = (permissionType) => {
        setErioonInfinity(permissionType);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const GenerateSecurePassword = () => {
        const generatePassword = (length = 12) => {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
            let password = "";
            const array = new Uint32Array(length);
            window.crypto.getRandomValues(array);
            for (let i = 0; i < length; i++) {
                password += chars[array[i] % chars.length];
            }
            return password;
        };

        setAccessPassword(generatePassword());
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords();
            setProjectId(project_id)
        }
    }, [user_id]);


    return (
        <div className="new_section_main_view">
            <p className="new_section_main_view_title fade-in">
                <i
                    className="fa-solid fa-chevron-left"
                    onClick={goBack}
                ></i>{" "}
                {t.access.new_access.title}
            </p>
            <p className="new_section_main_view_subtitle fade-in">
                Access credentials are scoped to individual projects, meaning they can only access the projects they were created for.
            </p>

            <div className="new_section_main_input_cont fade-in">
                <div className="new_section_main_input_container">
                    <div className="main_input_container">
                        {/* <p className="modal_pre_body_pricing_title">Access type</p>
                        <div className="ai_allow_cont_opt">
                            <button
                                className={`ai_allow_choice ${accessType == "GA" ? "selected" : ""}`}
                                onClick={() => setAccessType("GA")}
                            >
                                General access
                            </button>
                            <button
                                className={`ai_allow_choice ${accessType == "RAA" ? "selected" : ""}`}
                                onClick={() => (setAccessType("RAA"), generateRandomCredentials())}
                            >
                                RAA - REST API Access
                            </button>
                        </div> */}

                        {accessType == "GA" ? (
                            <div className="access_type_cont fade-in">
                                <div className="double_input_section">
                                    <div className="label_input_section">
                                        <label>{t.access.new_access.name}</label>
                                        <input
                                            className="description_area_input"
                                            placeholder="Jhon"
                                            value={accessName}
                                            onChange={(e) => setAccessName(e.target.value)}
                                        />
                                    </div>
                                    <div className="label_input_section">
                                        <label>{t.access.new_access.surname}</label>
                                        <input
                                            className="description_area_input"
                                            placeholder="Doe"
                                            value={accessSurname}
                                            onChange={(e) => setAccessSurname(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="double_input_section">
                                    <div className="label_input_section">
                                        <label>{t.access.new_access.email}</label>
                                        <input
                                            className="description_area_input"
                                            placeholder="jhondoe@example.com"
                                            value={accessEmail}
                                            onChange={(e) => setAccessEmail(e.target.value)}
                                        />
                                    </div>
                                    <div className="label_input_section">

                                        <label>{t.access.new_access.password}<button className="gen_password" onClick={GenerateSecurePassword}>{t.access.new_access.generate_password}</button></label>
                                        <div className="password_eye_role">
                                            <input
                                                autoComplete="new-password"
                                                className="description_area_input"
                                                placeholder="**************"
                                                value={accessPassword}
                                                type={showPassword ? "text" : "password"}
                                                onChange={(e) => setAccessPassword(e.target.value)}
                                            />
                                            <button className="show_passowrd_role" onClick={togglePasswordVisibility}>
                                                <i className={`fa-regular fa-eye${showPassword ? "" : "-slash"}`}></i>
                                            </button>
                                        </div>

                                    </div>
                                </div>

                                <div className="label_input_section">
                                    {/* <label>{t.access.new_access.access_type}</label> */}
                                </div>
                                <div className="resource_role_cont">
                                    <div className="label_checkbox_container">
                                        <div className="group_container_cont">

                                            <label >Erioon NoSQL Databases</label>
                                            <div className="single_role_item">
                                                <div className="single_role_item_option">
                                                    <div className={`single_label_checkbox ${erioonDB == "write" ? "checked" : ""}`} onClick={() => handleErioonDBPermissions("write")}>
                                                        <input
                                                            type="checkbox"
                                                            checked={erioonDB == "write" ? true : false}
                                                        />
                                                        <label>{t.access.new_access.read_write}</label>
                                                    </div>
                                                    <div className={`single_label_checkbox ${erioonDB == "read" ? "checked" : ""}`} onClick={() => handleErioonDBPermissions("read")}>
                                                        <input
                                                            type="checkbox"
                                                            checked={erioonDB == "read" ? true : false}
                                                        />
                                                        <label>{t.access.new_access.read_only}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="group_container_cont">
                                            <label >Erioon Compute</label>
                                            <div className="single_role_item">
                                                <div className="single_role_item_option">
                                                    <div className={`single_label_checkbox ${erioonInfinity == "fullAccess" ? "checked" : ""}`} onClick={() => handleErioonInfinityPermissions("fullAccess")}>
                                                        <input
                                                            type="checkbox"
                                                            checked={erioonInfinity == "fullAccess" ? true : false}
                                                        />
                                                        <label>{t.access.new_access.full_access}</label>
                                                    </div>
                                                    <div className={`single_label_checkbox ${erioonInfinity == "viewAccess" ? "checked" : ""}`} onClick={() => handleErioonInfinityPermissions("viewAccess")}>
                                                        <input
                                                            type="checkbox"
                                                            checked={erioonInfinity == "viewAccess" ? true : false}
                                                        />
                                                        <label>{t.access.new_access.view_access}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="access_type_cont fade-in">
                                <p className="new_section_main_view_subtitle">Rest API Access are credentials used for REST-API inserts. Those credentials are generated automatically and can be publishable.</p>


                                <p className="modal_pre_body_pricing_title">Connection string to pass as Bearer</p>
                                <div className="link_cont_file_share">
                                    <div className="link_file">
                                        <p>
                                            {accessPassword ? (
                                                <span>{`${accessEmail}:${accessPassword}`}</span>
                                            ) : (
                                                <div className="loading_link_container"></div>
                                            )}
                                        </p>
                                    </div>
                                    <button className="copy_clipboard_link_file_btn" onClick={handleCopyClick}>
                                        {copiedSecret ? <i className="fa-solid fa-check"></i> : <BiCopy />}
                                    </button>
                                </div>

                            </div>
                        )}
                    </div>

                </div>
                <div className="cost_preview_container">

                    {/* <div className="cost_preview_cont">
                        <p className="new_section_main_input_hint_title">
                            $1.99/month
                        </p>
                        <p className="new_section_main_input_hint_description">
                            {t.access.new_access.month_free}
                        </p>
                    </div> */}
                    <div className="preview_cont_db">
                        <div className="review_cont">
                            <p className="review_cont_title">{t.access.new_access.resume}</p>
                            <p className="review_cont_data">{t.access.new_access.name}<span>{accessName || <div className="loading_span"></div>}</span></p>
                            <p className="review_cont_data">{t.access.new_access.surname}<span>{accessSurname || <div className="loading_span"></div>}</span></p>
                            <p className="review_cont_data">{t.access.new_access.email}<span>{accessEmail || <div className="loading_span"></div>}</span></p>

                            <p className="review_cont_data">Erioon Databases<span>{erioonDB == "write" ? t.access.new_access.read_write_short : t.access.new_access.read_only_short || <div className="loading_span"></div>}</span></p>

                            <p className="review_cont_data">Erioon Compute<span>{erioonInfinity == "fullAccess" ? t.access.new_access.full_access_short : t.access.new_access.view_access_short || <div className="loading_span"></div>}</span></p>

                            <div className="label_input_section_db">
                                <label>{t.access.new_access.select_project}</label>
                                <select
                                    className="review_cont_data_select"
                                    value={projectId}
                                    onChange={(e) => setProjectId(e.target.value)}
                                >
                                    <option value="">{loading ? <Spinner loading={loading} /> : ""}</option>
                                    {records.map((record, index) => (
                                        <option value={record._id}>{record.project_name}</option>
                                    ))}
                                </select>

                            </div>
                        </div>
                        <ErrorMessage err={err} />
                        <button className="save_btn_db" onClick={handleSave}>

                            {loading ? (
                                <Spinner loading={loading} />
                            ) : (
                                // <>{t.access.new_access.confirm_invitation}</>
                                <>Create</>
                            )}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default NewAccess;
